import React from 'react';
import './card.scss';

const Card = ({ title, image, link, tools }) => {
  return (
    <div className='card'>
      <h3>{title}</h3>
      <div className='context'>
        <a
          href={'https://zmichgen.github.io/' + link}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img src={image} alt={title} />
        </a>
        <ul>
          {tools.map((tool, index) => (
            <li key={tool + index}>{tool}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

Card.defaultProps = {
  title: 'Title',
};

export default Card;
